import React from "react";
import "./styles.scss";
const UserInitials = ({
  initialsClass,
  userTextClass,
  icon,
  userText,
  onClick,
}) => {
  return (
    <div className={`user-initials ${initialsClass} `} onClick={onClick}>
      <span className={`user-text ${userTextClass}`}>{userText}</span>
      {icon ? (
        <div className="overlay-icon">
          <img src={icon} alt="icon" />
        </div>
      ) : null}
    </div>
  );
};

export default UserInitials;
